import React, { useEffect, useState } from 'react';
import '../styles/Home.css';
import co1 from '../assets/co1.png';
import co2 from '../assets/co2.png';
import co3 from '../assets/co3.png';
import co4 from '../assets/co4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Remove faWhatsapp from solid-svg-icons import
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
// Add separate import for brand icons
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Services from './Services';
import WhatsAppPopup from './WhatsAppPopup.js';
import Testimonial from './Testimonial.js';

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(true); // Show WhatsApp pop-up on page load

  const images = [co1, co2, co3, co4];

  // WhatsApp Redirection Function
  const handleWhatsAppRedirect = () => {
    const phoneNumber = "919492446913"; // Replace with your WhatsApp number
    const message = encodeURIComponent("Hello, a user just opened the application.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    window.open(whatsappUrl, "_blank"); // Open WhatsApp in new tab
    setShowPopup(false); // Hide popup after clicking
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="home">
      {/* WhatsApp Pop-up */}
      {showPopup && (
        <div className="whatsapp-popup">
          <p>Would you like to send a WhatsApp alert?</p>
          <button onClick={handleWhatsAppRedirect} className="whatsapp-button">
            <FontAwesomeIcon icon={faWhatsapp} /> Send Alert
          </button>
        </div>
      )}

      {/* Hero Section */}
      <section className="hero">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">Compassionate Services for Your Loved Ones</h1>
          <p className="hero-subtext">Dignified and respectful funeral arrangements with care and empathy.</p>
          <button className="book-button" onClick={() => window.location.href = 'tel:+919492446913'}>
            Book Now
          </button>
        </div>
      </section>

      {/* Image Carousel */}
      <section className="carousel">
        <div className="carousel-container">
          <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {images.map((src, index) => (
              <div key={index} className={`carousel-item ${index === currentIndex ? 'active' : ''}`}>
                <img src={src} alt={`Service showcase ${index + 1}`} className="carousel-image" />
              </div>
            ))}
          </div>
          <button className="carousel-button prev" onClick={handlePrev}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <button className="carousel-button next" onClick={handleNext}>
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
          <div className="carousel-dots">
            {images.map((_, index) => (
              <button key={index} className={`dot ${index === currentIndex ? 'active' : ''}`} onClick={() => setCurrentIndex(index)}></button>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section Link */}
      <section className="services-link">
        <Services />
        <Testimonial />
      </section>
      <WhatsAppPopup /> 
    </div>
  );
}

export default Home;
